import { Venue } from '~/store/venues/venues.types'

const normaliseName = (name: String) => name.replace('Soho House ', '')

export const alphabetiseVenues = (venues: Venue[]) => {
  return venues.sort((venueA, venueB) => {
    const nameA = normaliseName(venueA.name)
    const nameB = normaliseName(venueB.name)

    return nameA.localeCompare(nameB)
  })
}
